import { api } from './graphql';
import { isTenantFeaturesConflict, listedFlags, mergeSavedFeatures } from './adminTenantFeatures';

api.enhanceEndpoints({
  endpoints: {
    GetAdminTenants: { providesTags: ['AdminTenant'] },
    GetAdminTenant: { providesTags: ['AdminTenant'] },
    AddAdminTenant: { invalidatesTags: ['AdminTenant'] },
    ActivateAdminTenant: { invalidatesTags: ['AdminTenant'] },
    InactivateAdminTenant: { invalidatesTags: ['AdminTenant'] },
    UpsertAdminTenantIntegration: { invalidatesTags: ['AdminTenant'] },
    DeleteAdminTenantIntegration: { invalidatesTags: ['AdminTenant'] },
    UpsertMySqlAdminTenantIntegration: { invalidatesTags: ['AdminTenant'] },
    PatchBatchAdminTenant: {
      invalidatesTags: (result, error) =>
        error || !result || result.patchBatchAdminTenant.some((patch) => patch.errors?.length)
          ? ['AdminTenant']
          : ['AdminTenant', 'AdminTenantFeatures'],
    },
    MarkAdminTenantOnboardingUploadImported: { invalidatesTags: ['AdminTenant'] },
    GetAdminTenantRestockProviderSettings: { providesTags: ['AdminTenant'] },
    UpdateAdminTenantRestockProviderSettings: { invalidatesTags: ['AdminTenant'] },
    SetTenantBillingRateCard: { invalidatesTags: ['AdminTenant'] },
    SetTenantBillingFrequency: { invalidatesTags: ['AdminTenant'] },
    UpdateSubscription: { invalidatesTags: ['AdminTenant'] },
    SetTenantOnlinePaymentMaxAmountOverride: { invalidatesTags: ['AdminTenant'] },
    ClearTenantOnlinePaymentMaxAmountOverride: { invalidatesTags: ['AdminTenant'] },
    // Trial pipeline: the approval queue provides TrialRequest; resolving a request
    // (Approve/Link/Reject) invalidates it, and can create/alter a tenant (Approve
    // provisions a new tenant, Link starts a trial), so it also busts AdminTenant.
    AdminTrialRequests: { providesTags: ['TrialRequest'] },
    ResolveTrialRequest: { invalidatesTags: ['TrialRequest', 'AdminTenant'] },
    // Usage is read against each tenant's effective caps, so a tenant patch (trial limits,
    // kind) invalidates this snapshot along with the tenant itself.
    AdminTrialTenantUsage: { providesTags: ['AdminTenant'] },
    GetAdminTenantFeatures: { providesTags: ['AdminTenantFeatures', 'FeatureFlag'] },
    GetAdminFeatureFlagDefaults: { providesTags: ['FeatureFlag'] },
    SetAdminTenantFeatures: {
      // A re-read can return a projection that lags the save, so the save's answer updates the read instead.
      invalidatesTags: (result, _error, { input }) =>
        !input.dryRun && result && !result.setAdminTenantFeatures.errors?.length
          ? ['AdminTenant']
          : [],
      onQueryStarted: async ({ input }, { dispatch, queryFulfilled }) => {
        const fulfilled = await queryFulfilled.catch(() => null);
        const result = fulfilled?.data.setAdminTenantFeatures;
        const saved = result?.data;
        if (!result || !saved || (input.dryRun && !isTenantFeaturesConflict(result))) return;
        dispatch(
          api.util.updateQueryData(
            'GetAdminTenantFeatures',
            { tenantId: input.tenantId },
            (cached) => {
              cached.adminTenantFeatures = mergeSavedFeatures(
                cached.adminTenantFeatures,
                saved,
                listedFlags(input)
              );
            }
          )
        );
      },
    },
  },
});
